import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Home, Grid, Heart, Handbag, CircleUserRound } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import './MobileBottomNav.css';

const MobileBottomNav = () => {
  const { cartCount } = useCart();
  const { wishlistCount } = useWishlist();
  const { user } = useAuth();

  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile Navigation Bar">
      <NavLink
        to="/"
        className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
        end
      >
        <Home size={20} />
        <span className="mobile-nav-label">Home</span>
      </NavLink>

      <NavLink
        to="/collections"
        className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
      >
        <Grid size={20} />
        <span className="mobile-nav-label">Categories</span>
      </NavLink>

      <NavLink
        to="/wishlist"
        className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
      >
        <div className="nav-icon-wrap">
          <Heart size={20} />
          {wishlistCount > 0 && <span className="mobile-nav-badge">{wishlistCount}</span>}
        </div>
        <span className="mobile-nav-label">Wishlist</span>
      </NavLink>

      <NavLink
        to="/cart"
        className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
      >
        <div className="nav-icon-wrap">
          <Handbag size={20} />
          {cartCount > 0 && <span className="mobile-nav-badge">{cartCount}</span>}
        </div>
        <span className="mobile-nav-label">Bag</span>
      </NavLink>

      <NavLink
        to="/account"
        className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
      >
        <CircleUserRound size={20} />
        <span className="mobile-nav-label">{user ? 'Account' : 'Log in'}</span>
      </NavLink>
    </nav>
  );
};

export default MobileBottomNav;

